export type LegalDocumentVariables = {
  company: string;
  site: string;
  phone: string;
  email: string;
  address: string;
  city: string;
  country: string;
  province: string;
  postalCode: string;
  vatNumber: string;
  lastUpdated: string;
  privacyPolicyLink: string;
  termsAndConditionsLink: string;
  cookiesLink: string;
};

export const LiveStates = [
  "1H",
  "HT",
  "2H",
  "ET",
  "BT",
  "P",
  "SUSP",
  "INT",
  "LIVE",
];
export const NotStartedStates = ["TBD", "NS"];
export const FinishedStates = ["FT", "AET", "PEN"];
